export default __webpack_public_path__ + "static/media/reviewing-new.1149ac56.svg";